import { API, CurrencyType } from '@brg/api'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import economicUrlApi from "../helpers/economicUrlApi";
import { UserPaymentCurrency } from '../constants/types';

interface IUserCurrencyRequest {
    lang: string
}

export const getUserAccounts = createAsyncThunk<any, IUserCurrencyRequest>(
    'userCurrencies/getUserAccounts',
    async ({ lang }, thuncApi) => {
        try {
            let currencies = await economicUrlApi().getUserCurrencyAccountsV2();

            const RealMoney = currencies?.length && currencies.find((item: any) => item.currencyType === CurrencyType.RealMoney).amount
            const PlayMoney = currencies?.length && currencies.find((item: any) => item.currencyType === CurrencyType.PlayMoney).amount

            const payload = {
                currencies: API.toLang(currencies, lang),
                RealMoney,
                PlayMoney,
            }

            return payload          
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export interface userCurrenciesState {
    currencies?: UserPaymentCurrency[],
    RealMoney: number,
    PlayMoney: number,
    loading: boolean
    error: any
}

const initialState: userCurrenciesState = {
    currencies: [],
    // шорткат для основных валют
    RealMoney: 0,
    PlayMoney: 0,
    error: null,
    loading: false,
}

export const userCurrenciesSlice = createSlice({
    name: 'userCurrencies',
    initialState,
    reducers: {
        clearUserCurrenciesRequest: () => initialState,
    },
    extraReducers: {
        [getUserAccounts.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.currencies = action.payload.currencies;
            state.RealMoney = action.payload.RealMoney;
            state.PlayMoney = action.payload.PlayMoney;
        },
        [getUserAccounts.pending.toString()]: (state) => {
            state.loading = true;
        },
        [getUserAccounts.rejected.toString()]: (state, action) => {
            state.loading = false;
            state.error = action.payload
        },
    },
});

export default userCurrenciesSlice

export const selectorUserCurrencies = (state: any): userCurrenciesState => state.getUserCurrencies

export const { clearUserCurrenciesRequest } = userCurrenciesSlice.actionsimport { API, CurrencyType } from '@brg/api'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import economicUrlApi from "../helpers/economicUrlApi";
import { UserPaymentCurrency } from '../constants/types';

interface IUserCurrencyRequest {
    lang: string
}

export const getUserAccounts = createAsyncThunk<any, IUserCurrencyRequest>(
    'userCurrencies/getUserAccounts',
    async ({ lang }, thuncApi) => {
        try {
            let currencies = await economicUrlApi().getUserCurrencyAccountsV2();

            const RealMoney = currencies?.length && currencies.find((item: any) => item.currencyType === CurrencyType.RealMoney).amount
            const PlayMoney = currencies?.length && currencies.find((item: any) => item.currencyType === CurrencyType.PlayMoney).amount

            const payload = {
                currencies: API.toLang(currencies, lang),
                RealMoney,
                PlayMoney,
            }

            return payload          
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export interface userCurrenciesState {
    currencies?: UserPaymentCurrency[],
    RealMoney: number,
    PlayMoney: number,
    loading: boolean
    error: any
}

const initialState: userCurrenciesState = {
    currencies: [],
    // шорткат для основных валют
    RealMoney: 0,
    PlayMoney: 0,
    error: null,
    loading: false,
}

export const userCurrenciesSlice = createSlice({
    name: 'userCurrencies',
    initialState,
    reducers: {
        clearUserCurrenciesRequest: () => initialState,
    },
    extraReducers: {
        [getUserAccounts.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.currencies = action.payload.currencies;
            state.RealMoney = action.payload.RealMoney;
            state.PlayMoney = action.payload.PlayMoney;
        },
        [getUserAccounts.pending.toString()]: (state) => {
            state.loading = true;
        },
        [getUserAccounts.rejected.toString()]: (state, action) => {
            state.loading = false;
            state.error = action.payload
        },
    },
});

export default userCurrenciesSlice

export const selectorUserCurrencies = (state: any): userCurrenciesState => state.getUserCurrencies

export const { clearUserCurrenciesRequest } = userCurrenciesSlice.actions